export const getServiceChangeResetFields = (input = {}) => {
  const formType = typeof input === "string" ? input : input.formType;
  const hasSelectedService = typeof input === "string"
    ? true
    : input.hasSelectedService;
  const preserveCalendarSlot = typeof input === "object" && input.preserveCalendarSlot === true;
  // Clearing the service is a temporary step in replacing an existing booking.
  // Keep its slot and therapist; replacement service compatibility is checked next.
  if (formType === "edit_appointment") return ["resource_item_id"];
  if (!hasSelectedService) return ["staff_id", "resource_item_id", "start_time"];
  if (preserveCalendarSlot) return ["resource_item_id"];
  return ["staff_id", "resource_item_id", "start_time"];
};

const present = (value) => value !== undefined && value !== null && value !== "";

const readOptionId = (item) => {
  if (!present(item)) return "";
  if (typeof item !== "object") return item;
  return item.id ?? item.service_id ?? item.value ?? "";
};

const idSet = (items) => new Set(
  (Array.isArray(items) ? items : [])
    .map(readOptionId)
    .filter(present)
    .map(String),
);

/**
 * A new primary service may require a different staff member. Keep the booked
 * time for availability validation after that choice. Existing child services
 * are bookings in their own right, not selections from the new service's catalog;
 * removing them here would make the update API delete their appointments.
 */
export const reconcileEditAppointmentServiceChange = (service = {}, values = {}) => {
  const updates = [];
  const safeService = service && typeof service === "object" ? service : {};
  const safeValues = values && typeof values === "object" ? values : {};

  if (Array.isArray(safeService.staffservices)) {
    const offeredStaff = idSet(safeService.staffservices);
    const staffId = present(safeValues.staff_id) ? String(safeValues.staff_id) : "";
    if (staffId && !offeredStaff.has(staffId)) {
      updates.push({ field: "staff_id", value: "" });
    }
  }

  return updates;
};
